import { Loader } from "lucide-react";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

function LoadingModal({ message }: { message: string }) {
    const overlayRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                closeModal();
            }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, []);

    const closeModal = () => {
        if (overlayRef.current) {
            overlayRef.current.classList.add("hidden");
        }
    };

    return createPortal(
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            ref={overlayRef}
        >
            <div className="relative flex min-h-[200px] min-w-[250px] max-w-sm flex-col items-center justify-center gap-6 overflow-y-auto rounded-xl border border-border-color bg-background-color px-6 py-8 shadow-2xl sm:min-w-[400px] md:px-12">
                <Loader className="size-12 animate-spin text-primary" />
                <p className="text-center text-lg">{message}</p>
            </div>
        </div>,
        document.body,
    );
}

export default LoadingModal;
